export enum CurrencyEnum {
  AMD = 'AMD',
  USD = 'USD',
  EUR = 'EUR',
  RUR = 'RUR',
  GBP = 'GBP',
  CHF = 'CHF',
}

export enum CalculatorCurrencyEnum {
  AMD = 'AMD',
  USD = 'USD',
  EUR = 'EUR',
  RUR = 'RUR',
}
